import { render, staticRenderFns } from "./Desconto.vue?vue&type=template&id=b568b7fe&scoped=true&"
import script from "./Desconto.vue?vue&type=script&lang=js&"
export * from "./Desconto.vue?vue&type=script&lang=js&"
import style0 from "./Desconto.vue?vue&type=style&index=0&id=b568b7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568b7fe",
  null
  
)

export default component.exports